import Vue from "vue";

window.jQuery = window.$ = require('jquery');
var $ = window.jQuery;
import App from "./subscriptionform/App"
import store from "./subscriptionform/store"
import it from './subscriptionform/locale/it';
import VeeValidate, {Validator} from 'vee-validate';
import loading from 'vuejs-loading-screen'


// Register it globally
// main.js or any entry file.

import "./subscriptionform/directives"

function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) == (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = window.Laravel.csrfToken;
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios.defaults.headers.common['X-XSRF-TOKEN'] = getCookie('XSRF-TOKEN');
window.toastr = require('toastr');

Validator.extend('minorenne', {
    getMessage: field => 'Attenzione, questo modulo è riservato solo a ragazzi e ragazze minorenni!<br/>Visita il <a href="https://www.infaop.com">nostro sito</a> per scoprire i corsi per adulti, oppure conttataci a info@infaop.com ',
    validate: value => value ? value < 18 : true
});
Vue.use(loading, {
        bg: '#012e5ead'
    }
);
Vue.use(VeeValidate);
Validator.localize('it', it);
Vue.config.productionTip = false
new Vue({
    store,
    render: h => h(App)
}).$mount("#app")
